import { Module } from '@yandex-int/k-common';
import b from 'b_';
import { Button, showIntlMessageNotification, SimpleText, Text } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/src/components/constants';
import { copyTextToClipboard } from 'platform-components/utils';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';

import { getCourseContainerModulePromos } from './selectors';

import './course-container__lesson-promo.scss';

interface Props {
    module: Module;
}

export const CourseContainerLessonsPromo = ({ module }: Props) => {
    const dispatch = useDispatch();

    const moduleId = module.id;
    const courseContainerModulePromos = useSelector(getCourseContainerModulePromos);
    const data = courseContainerModulePromos?.[moduleId];

    const onClick = () => {
        copyTextToClipboard(data);

        ym('reachGoal', 'course_container_module_promo', { moduleId });

        dispatch(
            showIntlMessageNotification({
                closeDelay: COMMON_NOTIFICATION_DELAY,
                gravity: GRAVITIES.BOTTOM,
                messageId: 'courseContainer.module.promoCopied',
                theme: NOTIFICATION_THEMES.TOAST,
            })
        );
    };

    if (!data) {
        return null;
    }

    return (
        <div className={b('course-container', 'lesson-promo')} key={`course-container-module-${moduleId}-promo`}>
            <div className={b('course-container', 'lesson-promo-description')}>
                <Text id="courseContainer.module.promoPopupDescription" />
            </div>
            <div className={b('course-container', 'lesson-promo-data')}>
                <div className={b('course-container', 'lesson-promo-text')} {...accessibleClick(onClick)}>
                    <Text size={Text.SIZE.XXL} type={Text.TYPE.MARKDOWN}>
                        {data}
                    </Text>
                </div>
                <Button className={b('course-container', 'lesson-promo-copy-button')} onClick={onClick}>
                    <SimpleText id="courseContainer.module.promoCopyButton" />
                </Button>
            </div>
        </div>
    );
};
